import { render, staticRenderFns } from "./DocumentFieldNumericISOCompliant.vue?vue&type=template&id=3621a518&scoped=true&"
import script from "./DocumentFieldNumericISOCompliant.vue?vue&type=script&lang=js&"
export * from "./DocumentFieldNumericISOCompliant.vue?vue&type=script&lang=js&"
import style0 from "./DocumentFieldNumericISOCompliant.vue?vue&type=style&index=0&id=3621a518&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3621a518",
  null
  
)

export default component.exports